import React, { useState } from 'react';
import { Button, Stack } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RolesTable from './RolesTable';
import RoleFormModal from './RoleFormModal';

export default function RolesTab() {
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [pagination, setPagination] = useState({ page: 0, size: 10 });

  const handlePaginationChange = (page, size) => {
    setPagination({ page, size });
  };

  return (
    <>
      <Stack direction="row" justifyContent="flex-end" sx={{ pb: 2 }}>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => setCreateModalOpen(true)}>
          Add Role
        </Button>
      </Stack>

      <RolesTable searchQuery={pagination} onPaginationChange={handlePaginationChange} />

      <RoleFormModal open={createModalOpen} onClose={() => setCreateModalOpen(false)} mode="create" roleData={null} />
    </>
  );
}
